




















export default {
  data() {
    return {
      toTopScroll(event: any) {
        // const begin: Date = new Date();
        // @ts-ignore
        const begin: any = new Date() - 0,
          yOffset: number = window.pageYOffset,
          duration: number = 250,
          timer = setInterval(function() {
            // @ts-ignore
            let current: any = new Date() - begin;
            if (current > duration) {
              clearInterval(timer);
              current = duration;
            }
            window.scrollTo(0, yOffset * (1 - current / duration));
          }, 25);
      }
    };
  }
};
